<div id="related-links" class="l-row commentary">
  <div class="l-full-width-col">
    <h1>Energy Information Administration</h1>
    <ul>
      <li><a href="http://ir.eia.gov/ngs/ngs.html">Weekly Natural Gas Storage Report</a> and <a href="http://ir.eia.gov/ngs/methodology.html">methodology</a>.
      </li>
      <li>
        <a href="/naturalgas/weekly/">Natural Gas Weekly Update</a>
      </li>
      <li>
        Stage field-level data and map, <a
        href="/cfapps/ngqs/ngqs.cfm?f_report=RP7&f_sortby=&f_items=&f_year_start=&f_year_end=&f_show_compid=&f_fullscreen">annual</a> and <a href="/cfapps/ngqs/ngqs.cfm?f_report=RP8&f_sortby=&f_items=&f_year_start=&f_year_end=&f_show_compid=&f_fullscreen=">monthly</a>
      </li>
      <li><a href="/special/disruptions/socal/summer/">Southern California Daily Energy Report</a></li>
      <li><a href="/naturalgas/storagecapacity/">Annual Storage Capacity Report</a></li>
      <li>Downloadable storage data (historical)
        <ul>
          <li><a href="/dnav/ng/ng_stor_wkly_s1_w.htm">Weekly data</a></li>
          <li><a href="/dnav/ng/ng_stor_type_s1_m.htm">Facility type</a></li>
          <li><a href="/dnav/ng/ng_stor_cap_a_EPG0_SAC_Mmcf_a.htm">Storage capacity</a></li>
          <li><a href="/dnav/ng/ng_stor_lng_a_EPG0_SAL_MMcf_a.htm">LNG storage additions and withdrawals</a></li>
          <li><a href="/naturalgas/data.php#storage">Additional data</a></li>
        </ul>
      </li>
      <li><a href="/naturalgas/monthly/">Natural Gas Monthly</a></li>
      <li><a href="/naturalgas/annual/">Natural Gas Annual</a></li>
      <li><a href="/outlooks/steo/">Short Term Energy Outlook</a></li>
      <li><a href="/naturalgas/storage/basics/">Basics of Underground Storage</a></li>
    </ul>
    <h1>Federal Energy Regulatory Commission</h1>
    <ul>
      <li>Jurisdictional pending storage projects</li>
      <li>Jurisdictional pre-filed storage projects</li>
      <li>Jurisdictional storage projects since 2000</li>
    </ul>
    <h1>Department of Energy</h1>
    <ul>
      <li><a
      href="https://www.energy.gov/downloads/report-ensuring-safe-and-reliable-underground-natural-gas-storage">Ensuring Safe and Reliable Underground Natural Gas Storage</a></li>
    </ul>
    <h1>Department of Transportation, Pipeline and Hazardous Materials Safety Administration</h1>
    <ul>
      <li><a href="https://primis.phmsa.dot.gov/ung/index.htm">Natural Gas Storage</a></li>
    </ul>
    <h1>State Government Resources</h1>
    <ul>
      <li><a href="http://www.cpuc.ca.gov/aliso/">California Public Utility Commission Aliso Canyon information</a></li>
      <li><a href="https://www.michigan.gov/mpsc/0,4639,7-159-16385_59482-426107--,00.html#tab=Active">Michigan Natural Gas Storage Field Summary</a></li>
      <li><a href="http://www.oregon.gov/energy/facilities-safety/facilities/Pages/MST.aspx">Oregon Mist Underground Natural Gas Storage Facility</a></li>
    </ul>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/related-links/display-related-links/display-related-links.component.html